function s(t, e) {
  return Object.keys(t).reduce((o, u) => {
    const r = { ...o }, n = t[u], i = n !== null && typeof n == "object" && !Array.isArray(n);
    return r[u] = i ? s(n, e) : e(n), r;
  }, {});
}
function f(t) {
  return {
    toToken: () => s(t, (e) => ({ value: e })),
    toSemanticToken: (e = "") => s(t, (o) => ({ value: `{${e}.${o}}` }))
  };
}
function l(t) {
  return Object.entries(t).reduce((e, [o, u]) => {
    const [r, n] = o.split(".");
    return e != null && e[r] || (e[r] = {}), e[r][n] = u, e;
  }, {});
}
export {
  f as format,
  s as formatRecursive,
  l as toPandaObject
};
